import { App } from '@capacitor/app';
import { setupNavigationBar } from './navigationBar';
import { checkForUpdate } from './autoUpdater';
import { Device } from '@capacitor/device';
import { setupStatusBar } from './statusBar';
import { Capacitor } from '@capacitor/core';

export const performCapInit = async () => {
	const deviceInfo = await Device.getInfo();
	console.log('ℹ️\tDevice Info:', deviceInfo);
	setupNavigationBar();
	setupStatusBar();
	checkForUpdate().then((result) => {
		window.autoUpdateResult.status = result;
		console.log('Auto Update Result:', window.autoUpdateResult);
	});
	window.checkForUpdate = checkForUpdate;
	window.setupNavigationBar = setupNavigationBar;
	window.setupStatusBar = setupStatusBar;
};

if (Capacitor.isPluginAvailable('App')) {
	App.addListener('appStateChange', (event) => {
		console.log('App state changed. ', event);
	}).catch((error) => {
		console.warn('Unable to listen for app state changes', error);
	});
}

// App.addListener('appUrlOpen', (data) => {
// 	console.log('App opened with URL:', data);
// });

// App.addListener('appRestoredResult', (data) => {
// 	console.log('Restored state:', data);
// });

// const checkAppLaunchUrl = async () => {
// 	const { url } = await App.getLaunchUrl();

// 	console.log('App opened with URL: ' + url);
// };

// Wait for the DOM to be ready
document.addEventListener('deviceready', async () => {
	setTimeout(async () => {
		performCapInit();
	}, 1500); // Delay must be greater than splash screen hide delay
});
